var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAutofillBlackIcon = function SvgAutofillBlackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.083 13.333c.421.41 2.083 1.5 2.083 2.084m0 0c0 .583-1.662 1.674-2.083 2.083m2.083-2.083H1.499"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.833 18.333h.228c2.717 0 4.076 0 5.02-.665.268-.188.508-.414.712-.67.707-.889.707-2.167.707-4.725v-2.121c0-2.47 0-3.704-.39-4.69-.63-1.586-1.957-2.836-3.642-3.428-1.047-.367-2.358-.367-4.983-.367-1.498 0-2.248 0-2.847.21-.962.338-1.721 1.052-2.08 1.958-.225.563-.225 1.27-.225 2.68v4.318"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 10a2.777 2.777 0 0 0-2.777-2.777c-.556 0-1.21.096-1.749-.048a1.39 1.39 0 0 1-.982-.983c-.145-.54-.048-1.194-.048-1.749a2.78 2.78 0 0 0-2.777-2.776"
  })));
};
export default SvgAutofillBlackIcon;